import { Controller } from "@hotwired/stimulus"

// 条件によってフィールドの表示/非表示を切り替えるコントローラー
// data-destination-type-show-value="client" で表示する値を指定
export default class extends Controller {
  static targets = ["field", "select", "trigger"]
  static values = { show: String }

  connect() {
    let value = ""

    if (this.hasTriggerTarget) {
      const checked = this.triggerTargets.find(
          trigger => trigger.checked
      )

      value = checked?.value ?? ""
    } else if (this.hasSelectTarget) {
      value = this.selectTarget.value ?? ""
    }

    this.fieldTarget.hidden = value !== this.showValue
  }

  toggle(event) {
    const value = event.target.value
    const hidden = value !== this.showValue
    this.fieldTarget.hidden = hidden
    if (hidden) {
      const input = this.fieldTarget.querySelector("wa-select, wa-input")
      if (input) input.value = ""
    }
  }
}